export default {"src":"/_next/static/media/check.5bd6b953.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};